import { Injectable } from '@angular/core';
import { AbstractRelatorioService } from '../abstract-relatorio.service';
import { AbstractServicePrivate } from '../../service/abstract.service.private';
import { Observable } from 'rxjs';
import { RelatorioDTO } from '../../dtos/relatorio-dto';

@Injectable({
  providedIn: 'root'
})
export class RelatorioGlobalService extends AbstractServicePrivate {

  protected getBaseUrlPrivate(): string {

    return super.getBaseUrlPrivate() + 'relatorios';
  }

  protected getBaseUrlPublic(): string {
    throw new Error("Unsupported method!");
  }

  gerarRelatorioDeMarcacoesInternas(relatorioDTO: RelatorioDTO): Observable<Blob> {
    return this.http.post(`${this.getBaseUrlPrivate()}/global/marcacoesInternas`, relatorioDTO, { responseType: 'blob' });
  }
}
